import { render, staticRenderFns } from "./ResourceLoading.vue?vue&type=template&id=9e9945a6&"
import script from "./ResourceLoading.vue?vue&type=script&lang=js&"
export * from "./ResourceLoading.vue?vue&type=script&lang=js&"
import style0 from "./ResourceLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports